import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { LoginLayout, SetPassword } from 'merchant-components';

const RouteComponent = () => {
  const search = Route.useSearch()
  const navigate = useNavigate();
  const handleSuccess = () => search?.redirect && navigate({ to: search?.redirect });
  return <LoginLayout outlet={<SetPassword className="mx-auto" onSuccess={handleSuccess} />} />
}

export const Route = createFileRoute('/_merchant/password')({
  validateSearch: (search) => {return {redirect: search.redirect as string | undefined}},
  component: RouteComponent
});
